import { ReferenceData, ReferenceQuery } from 'chaika-frontend-types/frontend-cms';

import { LongList } from '@store/abstract/LongList';

export interface LaboratoryReferenceFilter extends ReferenceQuery {}

export class LaboratoryReferenceList extends LongList<ReferenceData, ReferenceData, LaboratoryReferenceFilter> {
    public static Name = 'laboratoryReferenceList' as const;

    public getLaboratoryReferencesByTableId(tableId: string): ReferenceData[] {
        return this.values.filter(item => item.referenceTableId === tableId);
    }

    protected create(params: ReferenceData): ReferenceData {
        return params;
    }

    protected filterValue(value: ReferenceData, { id, referenceTableId, ageInDays }: LaboratoryReferenceFilter) {
        return (
            this.filterFieldValueByArray(value, id, 'id') &&
            this.filterFieldValueByArray(value, referenceTableId, 'referenceTableId')
        );
    }
}
